// @flow

import React from 'react'
import $ from 'jquery'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reset, change } from 'redux-form'
import { Map } from 'immutable'
import bindAll from "lodash/bindAll";
import TalkExpertPage1 from './users/TalkExpertPage1'
import UserRegisterWizardFormThirdPageNew from './users/UserRegisterWizardFormThirdPageNew'
import initializers from '../../dependencies/initializers'
import { usersAddNavigationPage } from '../../actions/users'
import { translate } from '../../helpers/global'

import HeaderClean from '../partials/HeaderClean.jsx'
import FooterClean from '../partials/FooterClean.jsx'

import { UilTimes } from '@iconscout/react-unicons'

import logo1 from '../../images/client_logo/kai.png'
import logo2 from '../../images/client_logo/unicharm.png'
import logo3 from '../../images/client_logo/astra.png'
import logo4 from '../../images/client_logo/telkom-akses.png'
import logo5 from '../../images/client_logo/mufg.png'
import logo6 from '../../images/client_logo/nus.png'
import logo7 from '../../images/client_logo/ntu.png'
import logo8 from '../../images/client_logo/ui.png'
import logo9 from '../../images/client_logo/petrosea.png'
import logo10 from '../../images/client_logo/qiscus.png'
import logo11 from '../../images/client_logo/popskuljobs.png'
import logo12 from '../../images/client_logo/pulsifi.png'

type Props = {
	resetForm: Function,
	usersAddNavigationPage: Function,
	usersNavigationData: Map<string, any>
};

type State = {
	unblockTransition: Function,
	cachedUsersNavigationDataPage: string,
	option: String,
	setOption: Function,
	nextPage: Function,
	prevPage: Function
};

const segmentTypeOptions = [
	{value: "Talent Acquisition", label: "Talent Acquisition", description:'Hire top talent efficiently. Make data-driven hiring decisions.'},
	{value: "Talent Management", label: "Talent Management", description:'Develop and retain high-performing employees. Build a strong workforce.'},
	{value: "Small Medium Enterprise", label: "Small Medium Enterprise", description:'Hire the right people to grow your business. Optimize hiring processes.'},
	{value: "University Admission", label: "University Admission", description:'Select qualified students for enrollment. Build a diverse student body.'},
	{value: "Career Development Center", label: "Career Development Center", description:'Prepare students for successful careers. Measure student outcomes.'}
]

class TalkExpert extends React.Component<Props, State> {
	constructor(props) {
		super(props)

		this.state = {
			unblockTransition: () => {},
			cachedUsersNavigationDataPage: '',
			option: [],
			setOption: (val) => { this.setState({option: val}) },
			nextPage: () => {},
			prevPage: () => {},
			tempSegmentType:[]
		}

		bindAll(this, [
			"handleContinueClick",
			"handleClickHereClick",
			"handleSelectSegmentType"
		]);
	}

	componentDidMount() {
		const titleElement: Object = document.getElementsByTagName('title')

		titleElement[0].text = 'ASTRNT'
		window.scrollTo(0, 0);	
	}

	componentWillUnmount() {
		// this.state.unblockTransition()
		const {
			resetForm,
			usersAddNavigationPage
		} = this.props

		resetForm('UserRegisterWizardForm')
		usersAddNavigationPage(1)
	}

	handleLoginLink(e: Object): void {
		e.preventDefault()
			window.location = initializers.recruiter_host+'/auth/login'
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const {
			usersNavigationData,
			usersAddNavigationPage,
			url_location,
			history
		} = nextProps

		if (usersNavigationData.get('page') !== prevState.cachedUsersNavigationDataPage) {
			let page: number = usersNavigationData.get('page')

			const nextPage: Function = () => {
				usersAddNavigationPage(page + 1)
			}

			const previousPage: Function = () => {
				usersAddNavigationPage(page - 1)
			}

			switch(page) {
				case 2:
					// history.push('/registered')
					window.dataLayer.push({
						event: 'registered',
						page: {
						  url: url_location,
						  title: 'registered success'
						}
					  });
					return {
						cachedUsersNavigationDataPage: page,
					}
				default:
					return {
						cachedUsersNavigationDataPage: page,
						prevPage: previousPage,
						nextPage: nextPage,
					}
			}
		}

		return null
	}

	chooseOpt(val) {
	  if( val === 'I’m An Applicant' ) {
		$('.div-info').css('display', 'block')
		$('.box-option-1').removeClass('selected')
		$('.box-option-2').removeClass('selected')
		$('.box-option-3').addClass('selected')
	  } else if (val === 'Recruitment & Assessment') {
		$('.div-info').css('display', 'none')
		// $('#pop-1').css('display', 'none')
		$('.box-option-1').removeClass('selected')
		$('.box-option-2').addClass('selected')
		$('.box-option-3').removeClass('selected')
	  } else {
	  	$('.div-info').css('display', 'none')
	  	// $('#pop-1').css('display', 'none')
		$('.box-option-1').addClass('selected')
		$('.box-option-2').removeClass('selected')
		$('.box-option-3').removeClass('selected')
	  }

	  $('div.select-plan select').val(val).change();
	  this.props.changeFieldValue('how_you_use_astrnt', val)
	  this.setState({option: val})
	}

	handleContinueClick() {
		let option = this.state.tempSegmentType
		let selectedSegmentType = segmentTypeOptions.filter(x=> option.includes(x.value))

	  	this.setState({option: selectedSegmentType})
		let segmentTypeValue = option.join(',')
	  	this.props.changeFieldValue('segment_type', segmentTypeValue)

		$('#pop-1').css('display', 'none')
		$('.overlay').fadeOut('fast');
	}

	handleClickHereClick() {
		$('#pop-1').css('display', 'none')
		$('#pop-2').css('display', 'block')
		$('.div-info').css('display', 'block')
	}

	handleSelectSegmentType(val){
		let option = this.state.tempSegmentType
	  	if(option.includes(val)){
			option = option.filter(x=> x!=val)
		}else{
			option.push(val)
	  	}

	  	this.setState({tempSegmentType: option})
	}

	render() {
		const {
			globalGetLanguages,
		} = this.props

		const {
			tempSegmentType
		} = this.state

		return (
			<div id="register">

			<div className="overlay" style={{display: 'none'}} />

	        <HeaderClean />
	        <div className="pad-top desktop-hide" />
	        <section className="sec-reg">
	          <ul className="lay-reg">
	            <li>
	              <div className="desc-log">
	                <span>See what ASTRNT can do for your talent decisions</span>
	                A casual and helpful conversation to understand your challenges and explore how we can support you.
					<h2>What can I expect from this conversation?</h2>
	                <ul className="expert">
	                  <li><i className="fas fa-check" />Share your current challenges. You don’t need to have everything figured out</li>
	                  <li><i className="fas fa-check" />Get advice tailored to your goals, whether it’s talent acquisition, talent management, or university</li>
	                  <li><i className="fas fa-check" />Learn how other organisations are solving similar problems using ASTRNT</li>
	                  <li><i className="fas fa-check" />Explore our key features such as structured video interview and skill validation.</li>
	                  <li><i className="fas fa-check" />No pressure to commit. Just a conversation that helps you move forward</li>
	                </ul>
	              </div>
	            </li>
	            <li>
	              <div className="box-reg">
					{
						this.state.cachedUsersNavigationDataPage == '2' ? 
							<UserRegisterWizardFormThirdPageNew /> 
							: 
							<TalkExpertPage1
								previousPage={this.state.prevPage}
								onSubmit={this.state.nextPage}
								setOption={this.state.setOption}
								option={this.state.option}
								plan={this.props.plan}
								cdcId={this.props.cdcId} 
							/>
					}
	              </div>
	            </li>
	          </ul>
	        </section>
			<div className="section-white relative">
				<section className="partner">
					<div className="part-wrap">
						<ul>
							<li><a><img src={logo1} /></a></li>
							<li><a><img src={logo2} /></a></li>
							<li><a><img src={logo3} /></a></li>
							<li><a><img src={logo4} /></a></li>
							<li><a><img src={logo5} /></a></li>
							<li><a><img src={logo6} /></a></li>
							<li><a><img src={logo7} /></a></li>
							<li><a><img src={logo8} /></a></li>
							<li><a><img src={logo9} /></a></li>
							<li><a><img src={logo10} /></a></li>
							<li><a><img src={logo11} /></a></li>
							<li><a><img src={logo12} /></a></li>
						</ul>
					</div>
				</section>
			</div>
	        <FooterClean />
	      </div>
    )
	}
}

const mapStateToProps = (state, ownProps) => {
	let plan = 'es2t' // default plan
	let params = new URLSearchParams(window.location.search)
	let cdcId = '';
	if(ownProps?.location?.search && params.get('plan')) {
		plan = params.get('plan')
	} else if(ownProps?.location?.query?.plan) {
		plan = ownProps.location.query.plan
	}

	if(params && params.get('cdcId')) {
		cdcId = params.get('cdcId');
	}
	
	return {
		usersNavigationData: state.usersNavigationData,
		plan: plan,
		url_location:ownProps.location,
		globalGetLanguages:state.globalGetLanguages,
		cdcId,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		resetForm: (formName) => dispatch(reset(formName)),
		usersAddNavigationPage: (page) => dispatch(usersAddNavigationPage(page)),
		changeFieldValue: (field, value) => dispatch(change('UserRegisterWizardForm', field, value, true, true)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TalkExpert)
